import colors from './colors';
import index from './index.mdx';
import styleVariables from './style-variables';

export default {
  index,
  colors,
  styleVariables,
};
